function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "100%",
  y1: "50%",
  x2: "0%",
  y2: "50%",
  id: "linearGradient-1"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D36E1C",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFC45E",
  offset: "100%"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1.00000303,8.99090736 L0.947904199,8.98955067 C0.932868664,8.98876825 0.917849381,8.9876483 0.902858692,8.9861912 C0.875739802,8.9836137 0.849707265,8.98003313 0.824013904,8.97547142 C0.810350229,8.97293174 0.796636007,8.97019608 0.782974755,8.96717203 C0.76377933,8.96305399 0.744327079,8.95813227 0.725111101,8.9526502 C0.705627244,8.94698873 0.686424197,8.94088487 0.667387641,8.93419006 C0.556944927,8.89535025 0.455185674,8.83743034 0.366236239,8.76446977 C0.333390499,8.73763076 0.301505296,8.70788228 0.271249963,8.67568395 L0.34982339,8.7507121 C0.323396079,8.72807647 0.298163525,8.70408602 0.274233357,8.67884838 C0.26885065,8.67313055 0.266467351,8.67056788 0.264100063,8.66799606 C0.240800901,8.64269906 0.218712856,8.61608749 0.198028187,8.58836735 C0.191479809,8.57964746 0.185235079,8.57099681 0.179146327,8.56227264 C0.165811237,8.5430916 0.15286273,8.52305975 0.140627381,8.50255309 C0.12981951,8.48452859 0.119960643,8.46675432 0.110686808,8.44876319 C0.103159754,8.43408757 0.0957101009,8.41871359 0.0886485857,8.40312629 C0.0796442164,8.38326632 0.0714897884,8.36354039 0.0639955396,8.3436287 C0.0576633366,8.32685913 0.0517878504,8.30990238 0.0463625602,8.29274555 C0.0405207012,8.27413801 0.0351275466,8.25511319 0.0303098881,8.23597758 C0.0251071839,8.21551246 0.020685733,8.19529423 0.0168858007,8.17485759 C0.0138509089,8.15826009 0.0111704839,8.14150902 0.00891746138,8.12471429 C0.00302628716,8.08096865 3.02620938e-06,8.03629106 3.02620938e-06,7.99090736 L0.00249345768,8.06188239 C0.00108305172,8.04189279 0.000271339511,8.02187242 5.74180795e-05,8.00185032 L3.02620938e-06,7.99090736 L3.02620938e-06,1.99090736 C3.02620938e-06,1.43862261 0.447718276,0.990907361 1.00000303,0.990907361 C1.55228778,0.990907361 2.00000303,1.43862261 2.00000303,1.99090736 L2.00000303,1.99090736 L2,5.679 L4.93349439,2.92320294 C8.01389308,-0.151990886 12.7189916,-0.874012974 16.5694265,1.10596934 L16.8366436,1.24849603 C20.7345751,3.40331479 22.7375736,7.8763013 21.7492949,12.2191597 C20.7610163,16.5620181 17.0197068,19.7278063 12.5731779,19.9837254 C8.12664905,20.2396445 4.04683484,17.5239996 2.56682772,13.3232029 C2.38330594,12.8023016 2.65680611,12.2312538 3.17770745,12.0477321 C3.69860878,11.8642103 4.26965655,12.1377104 4.45317833,12.6586118 C5.63718402,16.0192491 8.90103539,18.1917651 12.4582585,17.9870298 C16.0154816,17.7822945 19.0085292,15.2496639 19.7991521,11.7753772 C20.589775,8.30109047 18.9873762,4.72270126 15.869031,2.99884626 C12.7506858,1.27499125 8.86814035,1.82124382 6.32477961,4.35966042 L6.32477961,4.35966042 L3.524,6.99 L7.00000303,6.99090736 C7.51283887,6.99090736 7.93551019,7.37694755 7.99327529,7.87428624 L8.00000303,7.99090736 C8.00000303,8.54319211 7.55228778,8.99090736 7.00000303,8.99090736 L7.00000303,8.99090736 L1.00000303,8.99090736 L1.00000303,8.99090736 Z",
  id: "path-2"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Login-and-2fa",
  stroke: "none",
  strokeWidth: 1,
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "2FA----Phone---enter-code",
  transform: "translate(-128.000000, -420.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "#FFFFFF",
  x: 0,
  y: 0,
  width: 414,
  height: 828
}), /*#__PURE__*/React.createElement("g", {
  id: "Group-Copy",
  transform: "translate(128.000000, 420.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "rotate-ccw",
  transform: "translate(1.000000, 2.000000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-3",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-2"
})), /*#__PURE__*/React.createElement("use", {
  id: "Combined-Shape",
  xlinkHref: "#path-2"
})))));

var SvgResend = function SvgResend(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgResend, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/resend.791aea3d.svg";
export { ForwardRef as ReactComponent };